import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveAddressType(app, dataToSave) {
  const { tenant, user = {}, data } = dataToSave;
  const adressTypeData = {
    tenant: tenant.id,
    doc_type: DocType.ADDRESS_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined),
  };
  return common.saveDoc(app, {
    source: data,
    doc: adressTypeData,
    user,
  });
}

export function fetchAddressTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'address_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function deleteAddressType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.ADDRESS_TYPE
  });
}

export function fetchAddressTypeById(app, params) {
  const { id } = params;
  const docType = DocType.ADDRESS_TYPE;
  return common.getDoc(app, { id, docType });
}
